export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: 'profile',
    name: '个人资料',
    description: '冲田杏梨的详细个人信息、成长经历、职业生涯时间线',
    icon: 'ri-user-heart-line',
    count: 12,
  },
  {
    slug: 'photobooks',
    name: '写真集',
    description: '冲田杏梨历年发行的写真集作品全收录',
    icon: 'ri-image-line',
    count: 28,
  },
  {
    slug: 'film-tv',
    name: '影视作品',
    description: '冲田杏梨参演的电影、电视剧及综艺节目',
    icon: 'ri-movie-line',
    count: 35,
  },
  {
    slug: 'news',
    name: '新闻动态',
    description: '冲田杏梨的最新新闻、活动资讯与媒体报道',
    icon: 'ri-newspaper-line',
    count: 56,
  },
  {
    slug: 'music',
    name: '音乐作品',
    description: '冲田杏梨参与的音乐作品、单曲及团体活动',
    icon: 'ri-music-line',
    count: 18,
  },
];